
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.362 15.604h13.4v2.413h-13.4zm16.579 0h1.381v2.413h-1.381zm-2.211 0h1.382v2.413H17.73zm.825-6.857a2.478 2.478 0 0 0 .829-1.9 2.951 2.951 0 0 0-3.035-2.793v1.27a1.529 1.529 0 1 1 0 3.047v1.27a3.43 3.43 0 0 1 3.592 3.3v1.778h1.381v-1.9a4.508 4.508 0 0 0-2.767-4.072zm-2.621 2.032h-1.379a1.636 1.636 0 0 1-1.66-1.65c0-.889.69-1.4 1.658-1.4V6.463a2.95 2.95 0 0 0-3.039 2.791 2.95 2.95 0 0 0 3.041 2.795h1.381a1.677 1.677 0 0 1 1.8 1.651v1.016h1.382v-1.27a2.982 2.982 0 0 0-3.184-2.667z"}})])
          )
        }
      }
    